module.exports = __webpack_public_path__ + "img/fig40.c4081f4c.jpg";